export const CREDIT_CARD = "CARD"
export const CREDIT_CARD_ONE_CLICK = "CARD_ONE_CLICK";
export const CASH_TO_CODE = "C2C"
export const PAYPAL = "PAYPAL"
export const DIRECT_DEBIT = "DIRECT_DEBIT"
export const ONLINE_BANK_TRANSFER = "ONLINE_BANK_TRANSFER"
export const BANK_TRANSFER = "BANK_TRANSFER"